module.exports = __webpack_public_path__ + "static/media/SCBsecurity.de102686.svg";